export default {
    callable: (element: HTMLElement) => {
        const mapUrl = element.dataset.mapurl;
        if (mapUrl) {
            const width = element.clientWidth || 400;
            const height = element.clientHeight || 400;

            const urlWithSize = `${mapUrl}&size=${width}x${height}`;
            element.style.backgroundImage = `url("${urlWithSize}")`;
        }
    },
};
